// Once a vehicle is picked the side panel is about that vehicle: Live | Journeys tabs on top,
// then the same header on both (back to all vehicles, state, name, registration). Copied in
// web/ and crm/.
import type { Vehicle } from '../api';
import { Link } from './Links';
import { mapState, StateIcon } from './VehicleState';

export function VehicleTabs({ vehicleId, active }: { vehicleId: number; active: 'live' | 'journeys' }) {
  return (
    <nav className="vtabs" aria-label="Vehicle views">
      <Link to={`/?vehicle=${vehicleId}`} aria-current={active === 'live' ? 'page' : undefined}>Live</Link>
      <Link to={`/vehicles/${vehicleId}/journeys`} aria-current={active === 'journeys' ? 'page' : undefined}>Journeys</Link>
    </nav>
  );
}

export function VehicleHeader({ vehicle, onBack, sub }: { vehicle: Vehicle; onBack?: () => void; sub?: string }) {
  const state = mapState(vehicle);
  return (
    <div className="vhead">
      {onBack
        ? <button type="button" className="link small vhead-back" onClick={onBack}>← All vehicles</button>
        : <Link to="/" className="small vhead-back">← All vehicles</Link>}
      <div className="vhead-main">
        <StateIcon state={state} course={vehicle.position?.course ?? null} size={30} />
        <div>
          <h1>{vehicle.name}</h1>
          <p className="muted">{sub ?? (vehicle.registration || ' ')}</p>
        </div>
      </div>
    </div>
  );
}
